module.exports = __webpack_public_path__ + "img/title-6.17bce48d.png";